import React, { useEffect, useState } from 'react';
import { getSectorWeights, updateSectorWeights } from '../../api';
import { useToast } from '../../components/Toast';

const CLUSTER_LABELS = [
  { key: 'cl01_weight', label: 'CL-01 Marché' },
  { key: 'cl02_weight', label: 'CL-02 Business Plan' },
  { key: 'cl03_weight', label: 'CL-03 Solidité Fi.' },
  { key: 'cl04_weight', label: 'CL-04 Innovation' },
  { key: 'cl05_weight', label: 'CL-05 Équipe' },
  { key: 'cl06_weight', label: 'CL-06 Org. Comm.' },
  { key: 'cl07_weight', label: 'CL-07 Maturité Fi.' },
  { key: 'cl08_weight', label: 'CL-08 RGPD' },
  { key: 'cl09_weight', label: 'CL-09 Notoriété' },
  { key: 'cl10_weight', label: 'CL-10 RSE' },
  { key: 'cl11_weight', label: 'CL-11 Conformité' },
  { key: 'cl12_weight', label: 'CL-12 Ratio' },
];

export default function AdminWeights() {
  const toast = useToast();
  const [weights, setWeights] = useState([]);
  const [edited, setEdited] = useState({});
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    getSectorWeights().then(setWeights).catch(console.error);
  }, []);

  const handleChange = (id, key, value) => {
    setEdited(e => ({ ...e, [id]: { ...(e[id] || {}), [key]: parseFloat(value) || 0 } }));
  };

  const handleSave = async (sector) => {
    setSaving(sector.id);
    const data = { ...sector, ...(edited[sector.id] || {}) };
    try {
      await updateSectorWeights(sector.id, data);
      const updated = await getSectorWeights();
      setWeights(updated);
      setEdited(e => { const n = { ...e }; delete n[sector.id]; return n; });
    } catch (err) {
      toast.error(err.message);
    }
    setSaving(null);
  };

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: 8 }}>Pondérations Sectorielles</h1>
        <p style={{ color: 'var(--text-light)', marginBottom: 32, fontSize: 14 }}>
          Ajustez les coefficients de pondération pour chaque cluster par secteur. Ces coefficients déterminent la Note Sectorielle ISI.
        </p>

        <div style={{ overflowX: 'auto' }}>
          <table className="matrix-table">
            <thead>
              <tr>
                <th style={{ minWidth: 100 }}>Secteur</th>
                {CLUSTER_LABELS.map(c => <th key={c.key} style={{ minWidth: 80, fontSize: 11 }}>{c.label}</th>)}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {weights.map(w => {
                const isEdited = !!edited[w.id];
                return (
                  <tr key={w.id}>
                    <td style={{ fontWeight: 600 }}>{w.secteur}</td>
                    {CLUSTER_LABELS.map(c => {
                      const val = edited[w.id]?.[c.key] ?? parseFloat(w[c.key]);
                      const isDefault = val === 1;
                      return (
                        <td key={c.key} style={{ padding: 4 }}>
                          <input type="number" step="0.1" min="0" max="5" value={val}
                            onChange={e => handleChange(w.id, c.key, e.target.value)}
                            style={{ width: 60, padding: '6px 8px', border: '1px solid var(--border)', borderRadius: 4,
                              fontSize: 13, textAlign: 'center', fontFamily: 'inherit',
                              background: isDefault ? 'white' : '#FFF3E0', fontWeight: isDefault ? 400 : 600 }} />
                        </td>
                      );
                    })}
                    <td>
                      <button onClick={() => handleSave(w)} disabled={!isEdited || saving === w.id}
                        className="btn btn-primary" style={{ fontSize: 11, padding: '4px 12px', opacity: isEdited ? 1 : 0.4 }}>
                        {saving === w.id ? '...' : 'Sauver'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className="card" style={{ marginTop: 32 }}>
          <h3 style={{ marginBottom: 12 }}>Formule de la Note Sectorielle</h3>
          <p style={{ fontSize: 14, color: 'var(--text-light)', lineHeight: 1.8 }}>
            <strong>Note Sectorielle ISI</strong> = Somme(Score_Cluster_i × Poids_i) / Somme(Poids_i)<br />
            Un coefficient de <strong>1.0</strong> = poids standard. Au-dessus de 1.0 = le cluster pèse davantage dans la note finale.
            En-dessous de 1.0 = impact réduit.
          </p>
        </div>
      </div>
    </div>
  );
}
